import { deleteImage, uploadImage } from "../files";
import { Database } from "types/supabase";
import { supabaseClient } from "supabase";

export type UpdateEventParams = {
  id: Database["public"]["Tables"]["events"]["Row"]["id"];
  uid: Database["public"]["Tables"]["events"]["Row"]["uid"];
  title: Database["public"]["Tables"]["events"]["Row"]["title"];
  sub_title: Database["public"]["Tables"]["events"]["Row"]["sub_title"];
  description: Database["public"]["Tables"]["events"]["Row"]["description"];
  title_pt: Database["public"]["Tables"]["events"]["Row"]["title_pt"];
  sub_title_pt: Database["public"]["Tables"]["events"]["Row"]["sub_title_pt"];
  description_pt: Database["public"]["Tables"]["events"]["Row"]["description_pt"];
  price: Database["public"]["Tables"]["events"]["Row"]["price"];
  price_pt: Database["public"]["Tables"]["events"]["Row"]["price_pt"];
  start_time: Database["public"]["Tables"]["events"]["Row"]["start_time"];
  finish_time: Database["public"]["Tables"]["events"]["Row"]["finish_time"];
  currPicture: Database["public"]["Tables"]["events"]["Row"]["picture"];
  organizer_id: Database["public"]["Tables"]["events"]["Row"]["organizer_id"];
  newPicture?: File;
  venue: Database["public"]["Tables"]["events"]["Row"]["venue"];
  venue_name: Database["public"]["Tables"]["events"]["Row"]["venue_name"];
  venue_address: Database["public"]["Tables"]["events"]["Row"]["venue_address"];
  venue_city: Database["public"]["Tables"]["events"]["Row"]["venue_city"];
  city_id: Database["public"]["Tables"]["events"]["Row"]["city_id"];
  venue_description: Database["public"]["Tables"]["events"]["Row"]["venue_description"];
  venue_location_lat: Database["public"]["Tables"]["events"]["Row"]["venue_location_lat"];
  venue_location_long: Database["public"]["Tables"]["events"]["Row"]["venue_location_long"];
  published: Database["public"]["Tables"]["events"]["Row"]["published"];
  cancelled: Database["public"]["Tables"]["events"]["Row"]["cancelled"];
  tags: Database["public"]["Tables"]["tags"]["Row"]["id"][];
  main_tag: Database["public"]["Tables"]["events"]["Row"]["main_tag"];
  is_recommended: Database["public"]["Tables"]["events"]["Row"]["is_recommended"];
  registration_link: Database["public"]["Tables"]["events"]["Row"]["registration_link"];
  made_by_organizer?: boolean | null;
};

export const updateEvent = async ({
  id,
  uid,
  title,
  sub_title,
  description,
  title_pt,
  sub_title_pt,
  description_pt,
  price,
  price_pt,
  start_time,
  finish_time,
  currPicture,
  newPicture,
  organizer_id,
  venue_address,
  venue_city,
  city_id,
  venue_description,
  venue_location_lat,
  venue_location_long,
  venue_name,
  venue,
  published,
  cancelled,
  tags,
  main_tag,
  is_recommended,
  registration_link,
  made_by_organizer,
}: UpdateEventParams) => {
  // Upload new picture if it exists
  let picturePath = null;
  if (newPicture) {
    picturePath = await uploadImage(
      newPicture,
      `${Date.now()}.${newPicture.type.split("/")[1]}`,
      "events",
      uid!
    );
    if (currPicture) {
      deleteImage(currPicture!.split("/").slice(-2).join("/"), "events");
    }
  }

  const updatedEvent = {
    title,
    sub_title,
    organizer_id,
    description,
    title_pt,
    sub_title_pt,
    description_pt,
    price: price === "" ? null : price,
    price_pt: price_pt === "" ? null : price_pt,
    start_time,
    finish_time,
    picture: currPicture,
    venue_address,
    venue_city,
    city_id,
    venue_description,
    venue_location_lat,
    venue_location_long,
    venue_name,
    venue,
    published,
    cancelled,
    tags,
    main_tag,
    is_recommended,
    registration_link,
    made_by_organizer,
  };

  if (picturePath) {
    updatedEvent.picture = picturePath;
  }

  const { error } = await supabaseClient
    .from("events")
    .update(updatedEvent)
    .eq("id", id);

  if (error) {
    throw error;
  }

  return updatedEvent;
};
